import { Component, OnInit, ɵConsole, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
// import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
declare var app;

@Component({
  selector: 'app-mz-leave-approval',
  templateUrl: './mz-leave-approval.component.html',
  styleUrls: ['./mz-leave-approval.component.scss']
})
export class MzLeaveApprovalComponent extends GridBaseCase {
  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  addobject: any = {};
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  isRole:boolean = false;//是否管理层
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { super(); 
     /**
     * 设置默认当前年月
     */
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.month = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
  }

  // ngOnInit() {
  // }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  EventBox(event){
    const that =this;
    if(event.detail.checked){
      that.dataArrayList.forEach(item=>{
        item.isCheck=true;
      });
    }else{
      that.dataArrayList.forEach(item=>{
        item.isCheck=false;
      });
    }
    
  }
  LoadData(PageNumber) {
    let that = this;
      try{
        if(that.com.GetAccount.Roles){
          that.com.GetAccount.Roles.forEach(role=>{
            if(role.Code=="1007"){//如果是管理层不可审批
              that.isRole=true;
            }
          });
        }
      }catch(err){
          console.log(err);
      }
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage =30;//app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      let obj = {};
      if (!that.searchDate) {
        let nowyear: any = that.com.getNow.split('-')[0];
        let nowmonth: any = that.com.getNow.split('-')[1];
        obj["a_AuditDate"] = nowyear + "-" + nowmonth;
        let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
        let day = new Date(nowyear, nowmonth, 0);
        let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
        that.searchDate = that.com.BetweenDate(startDate, endDate);
      }
         obj["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
         obj["l_AuditStatus"]="0";

      //请假列表
      if (that.searchDate) {
        obj["a_AuditDate"] = that.searchDate;
      }
      body.RequestBody = JSON.stringify(obj);
      // if(that.baseService.storeSearch.name){

      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id,"a_name":that.baseService.storeSearch.name});
      // }else{
      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
      // }
      // body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
         /****上拉加载数据begin****/
         that.RecordCount = data.Status.RecordCount;
         if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
           that.infiniteScroll.disabled = true;
         }else{
           that.infiniteScroll.disabled = false;
         }
         /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  changeMonth(type, $event:any="") {
    const that=this;
    let t = type;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01";
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }
    } else if (t == 'datetime') {
      console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    // this.searchDate = current_year + "-" + current_month;
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }

  EventLink(ev: any, item: any) {
    if (item.isCheck) {
      item.isCheck = false;
    } else {
      item.isCheck = true;
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }


  /**
   * 审批
   * @param event 通过:true,驳回:false
   */
  EventClick(event: Boolean) {
    //console.log(event);
    const that = this;
    let objArray: Array<any> = [];
    let webcontext: WebParameterContext = new WebParameterContext();
    webcontext.Account = that.com.GetAccount;
    webcontext.ConfigName = "LeaveApproveXML";
    webcontext.ConfigType = "form";
    webcontext.OpType = "edite";
    webcontext.ID = that.com.GetAccount.Id;
    // webcontext.SpecialParameter = "LeaveApproval"
    if (that.dataArrayList.length > 0 && that.dataArrayList.findIndex(itme => itme.isCheck) >= 0) {
      that.addobject = [];
      that.dataArrayList.forEach((items, index) => { // obj["CHILDOBJ_TypeOfLeaveSysUserXML"]={"Info":{"FormFKElementModel":"a_FK_Leave_ID","ProviderFKElementModel":"a_ID","FormConfigName":"TypeOfLeaveSysUserXML"},"Datas":[]};
        if (items.isCheck) {
          that.addobject.push(items.id.value);
        }
      });
     
      let requestbody={};
          requestbody["a_FK_Leav_ID"]= that.addobject;
          requestbody["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
          if(event){
            requestbody["a_StatsType"]=1;//审核通过，一个人审核则审核通过
          }else{
            requestbody["a_StatsType"]=2;//审核驳回，一个人审核则审核驳回
          }
      webcontext.RequestBody = JSON.stringify(requestbody);
      // console.log(JSON.stringify(webcontext));
      that.msg.Confirm("确定提交吗？","取消","确定").then(res=>{
        if(res){
          that.http.post(app.DEFAULTURL, webcontext).then(data => {
            if (data.ResponseMessage.Success) {
                 that.msg.Alert("提交成功").then(res=>{
                  that.LoadData(1);
                 });
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          });
        }
      });
    } else {
      that.msg.Alert("必须选择一项");
    }
  }
  EventDetail(ele, item) {
    let evs = ele.url || '';
    if (evs.trim()) {
      if (evs.indexOf("http") > 0) {
        this.com.goWebPage(evs, '详情');
      } else {
        // console.log("1008611");
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/GETEDITE/" + item.id.value + "&" + item.chilren_ID.value);
        this.com.Go(evs + "/GETEDITE/" + item.id.value + "&" + item.chilren_ID.value);

        //TODO:跳转方法
        // this.router.navigateByUrl(evs + "/GETEDITE/" + parms.id.value);
      }
    }
  }

}
